import { useEffect, useRef } from "react";
import { api, type Message } from "../api";
import { upsertMessage, useStore } from "../store";
import { Smile } from "./icons";
import { toast, useMe } from "./ui";

export const QUICK = ["👍", "✅", "👀", "🙏", "😂", "🎉"];
const MORE = ["❤️", "🔥", "👏", "💯", "🙌", "😅", "😊", "🤔", "😮", "😢", "👌", "💪", "⚡", "🚀", "📌", "⏳", "❌", "⚠️", "💰", "📞", "📎", "🏨", "☕", "🙈"];

export async function toggle(m: Message, emoji: string, meId: number) {
  m = { ...m, reactions: m.reactions ?? [] };
  // Show it at once; the server's answer replaces it.
  const had = m.reactions.find((r) => r.emoji === emoji)?.users.includes(meId);
  const reactions = had
    ? m.reactions.map((r) => (r.emoji === emoji ? { ...r, users: r.users.filter((u) => u !== meId) } : r)).filter((r) => r.users.length)
    : m.reactions.some((r) => r.emoji === emoji)
      ? m.reactions.map((r) => (r.emoji === emoji ? { ...r, users: [...r.users, meId] } : r))
      : [...m.reactions, { emoji, users: [meId] }];
  upsertMessage({ ...m, reactions });
  try { upsertMessage(await api.react(m.id, emoji)); }
  catch (e: any) { upsertMessage(m); toast(e.message || "Couldn't react"); }
}

export function ReactionRow({ m }: { m: Message }) {
  const me = useMe();
  const users = useStore((s) => s.users);
  if (!m.reactions?.length) return null;
  return (
    <div className="reacts">
      {m.reactions.map((r) => (
        <button key={r.emoji} className={r.users.includes(me.id) ? "mine" : ""} onClick={() => toggle(m, r.emoji, me.id)}
          title={r.users.map((u) => (u === me.id ? "You" : users[u]?.name ?? "Someone")).join(", ")}>
          <span className="e">{r.emoji}</span>{r.users.length}
        </button>
      ))}
    </div>
  );
}

export function Picker({ m, onClose }: { m: Message; onClose: () => void }) {
  const me = useMe();
  const box = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const k = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    const c = (e: MouseEvent) => !box.current?.contains(e.target as Node) && onClose();
    addEventListener("keydown", k); setTimeout(() => addEventListener("mousedown", c));
    return () => { removeEventListener("keydown", k); removeEventListener("mousedown", c); };
  }, [onClose]);
  const pick = (e: string) => { toggle(m, e, me.id); onClose(); };
  return (
    <div className="picker" ref={box}>
      {[...QUICK, ...MORE].map((e) => <button key={e} onClick={() => pick(e)}>{e}</button>)}
    </div>
  );
}

export { Smile };
